import React, { Fragment } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../components/header_logged'
import Footer from '../../../components/footer'
import Head from '../../../components/head';
import PrestContasLogged from '../../../components/auth/contas'

function PrestContasLoggedScreen() {
        return (
            <Fragment>
                <Head titulo="Módulo de Prestação de Contas" />
                <HeaderLogged />
                <Container>
                   <PrestContasLogged />
                </Container>
                <Footer />
            </Fragment>
        );
}

export default PrestContasLoggedScreen;